import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e88c1668"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex-row-center-start no_rem_tag"
}
const _hoisted_2 = { class: "no_rem_lh-40 font-blod" }
const _hoisted_3 = { class: "flex-column no_rem_tag_minititle no_rem_ml-16" }
const _hoisted_4 = { class: "no_rem_lh-16" }
const _hoisted_5 = { class: "no_rem_lh-16 no_rem_mt-4" }
const _hoisted_6 = {
  key: 1,
  class: "flex-row-center-start tag"
}
const _hoisted_7 = { class: "lh-22 font-blod" }
const _hoisted_8 = { class: "flex-column tag_minititle ml-12" }
const _hoisted_9 = { class: "lh-12" }
const _hoisted_10 = { class: "lh-12 mt-2" }

import {
		withDefaults
	} from 'vue';
	import useStore from '../store';
	// 父->子 属性值
	interface PropType {
		content?: any
	}
	
	
export default /*#__PURE__*/_defineComponent({
  __name: 'TagView',
  props: {
    content: { default: {
			name: "",
			englishHead: "",
			englishFooter: "",
		} }
  },
  setup(__props: any) {

const props = __props as { content: any };

	
	const store = useStore;

return (_ctx: any,_cache: any) => {
  return (!_unref(store).state.is_phone)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(props.content.name), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(props.content.englishHead), 1),
          _createElementVNode("span", _hoisted_5, _toDisplayString(props.content.englishFooter), 1)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(props.content.name), 1),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(props.content.englishHead), 1),
          _createElementVNode("span", _hoisted_10, _toDisplayString(props.content.englishFooter), 1)
        ])
      ]))
}
}

})